"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Site = void 0;
var Site;
(function (Site) {
    Site["bosno"] = "bosno";
    Site["mercedes"] = "mercedes";
})(Site = exports.Site || (exports.Site = {}));
//# sourceMappingURL=site.js.map